import React from 'react';
import type {
	FormEnrollment as FormEnrollmentModel,
	FormEnrollmentDto,
} from 'models/enrollments/FormEnrollment';
import { FormViewer } from 'components/forms/FormViewer';
import type { UserSubmissionDto } from 'models/projects/UserSubmissionDto';

type Props = {
	enrollment: FormEnrollmentModel | FormEnrollmentDto;
	className?: string;
	onSubmit?: (submissionDto: UserSubmissionDto) => void;
	workflowId?: string;
	nodeId?: string;
	projectId?: string;
	isDisabled?: boolean;
};

const getFormId = (enrollment: FormEnrollmentModel | FormEnrollmentDto): string => {
	if ('formId' in enrollment && typeof enrollment.formId === 'string') {
		return enrollment.formId;
	}
	return '';
};

export const FormEnrollmentView: React.FC<Props> = ({ enrollment, className = '', onSubmit, workflowId, nodeId, projectId, isDisabled }) => {
	return (
		<div className={`p-4 border rounded bg-white shadow-sm ${className}`}>
			<div className="flex items-center justify-between">
				<div>
					<FormViewer
						form={null}
						isDisabled={isDisabled ?? false}
						formId={getFormId(enrollment)}
						onSubmit={onSubmit}
						workflowId={workflowId}
						nodeId={nodeId}
						projectId={projectId}
					/>
				</div>
			</div>
		</div>
	);
};

export default FormEnrollmentView;
